/**
 * Created by kb on 2017/11/20.
 */
const getters = {
  roles: state => state.system.roles,
  user: state => state.system.user,
  token: state => state.system.token,
  menus : state => state.system.menus,
  PagePermissions : state => state.system.PagePermissions,
  isLoading : state => state.system.isLoading,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js